const doc = [({"en":({"js":({"admin":({"show_boxes":({"partial":({"the_show_box_was_deleted":"The show box was deleted.", "add_show_box":"Add show box"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;